import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../../components/AuthForm";
import ImageSideContainer from "../../../components/ImageSideContainer";
import Label from "../../../components/Label";

const LogIn: FunctionComponent = ({}) => {
  const navigate = useNavigate();
  return (
    <>
      <ImageSideContainer>
        <header className="signUp_header">
          <Label tag="h1">Iniciar sesión</Label>
          <Label tag="p" variants="body1">
            Para acceder a nuestro catálogo de productos online complete los
            siguientes datos:
          </Label>
        </header>
        <section>
          <AuthForm />
          <div className="register-cta">
            <p className="register-cta__question">¿Aún no tienes una cuenta?</p>
            <a
              className="register-cta__action"
              onClick={() => navigate("/sign-up")}
            >
              Registrarme
            </a>
          </div>
        </section>
      </ImageSideContainer>
    </>
  );
};

export default LogIn;
